import { useFormikContext } from 'formik';
import { styled, TextField } from '@material-ui/core';

const TextFieldStyled = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    borderRadius: '0.75rem'
  }
});

const FormikTextField = ({ name, ...rest }) => {
  const { handleChange, handleBlur, values, touched, errors } = useFormikContext();

  return (
    <TextFieldStyled
      color="primary"
      error={!!touched[name] && !!errors[name]}
      fullWidth
      helperText={touched[name] ? errors[name] : ''}
      margin="normal"
      name={name}
      onBlur={handleBlur}
      onChange={handleChange}
      value={values[name]}
      variant="outlined"
      {...rest}
    />
  );
};

export default FormikTextField;
